import find from 'lodash/find'
import orderBy from 'lodash/orderBy'
import isEmpty from 'lodash/isEmpty'
import type { Template } from '@ztechapps/common.contract'
import { useState } from 'react'
import { useDeepCompareEffect } from '../useDeepCompareEffect'
import { useTemplateList } from './useTemplateList'

const allFilterTemplate = { _id: '_show_all_', name: 'Show All', value: '{}' } as unknown as Template

export type UseInitialFilterTemplateProps = { category: string; providedFilterTemplate?: Template }

export type UseInitialFilterTemplate = {
  filterTemplates: Template[]
  initialFilterTemplate: Template
  allFilterTemplate: Template
}
/**
 * This will get the default template
 */
export const useInitialFilterTemplate = ({ category, providedFilterTemplate }: UseInitialFilterTemplateProps): UseInitialFilterTemplate => {
  const { list, error, loading } = useTemplateList({ filter: { category } })
  const [filterTemplates, setFilterTemplates] = useState<Template[]>(null)
  const [initialFilterTemplate, setInitialFilterTemplate] = useState<Template>(null)

  useDeepCompareEffect(() => {
    //if there is list error and still loading then just return
    if (error || loading) return

    //whatever the results from db, always insert on the first item the default filter
    let withDefaultFilterList = [...list]
    withDefaultFilterList = orderBy(withDefaultFilterList, ['name'], ['asc'])
    withDefaultFilterList.unshift(allFilterTemplate)
    setFilterTemplates(withDefaultFilterList)

    //when there is no value on template, look from the list where the isDefault is true
    let _filterTemplate = null
    //just a flag when to run teh onFilter, which will happen when the filter template is default or from the empty

    //when the templateId is provided, look for it
    if (providedFilterTemplate) {
      _filterTemplate = find(withDefaultFilterList, ({ _id }) => _id === providedFilterTemplate?._id)
    }

    //if still can go here, it means the above statement cannot find something
    if (isEmpty(_filterTemplate) && isEmpty(providedFilterTemplate?.value)) {
      _filterTemplate = find(withDefaultFilterList, ({ isDefault }) => isDefault)
    }

    //if still cannot find it from the above statement, then fallback to the default filter
    if (isEmpty(_filterTemplate)) {
      if (!isEmpty(providedFilterTemplate?.value)) {
        _filterTemplate = { ...providedFilterTemplate, name: 'Custom filter', _id: '_custom_' }
      } else {
        _filterTemplate = allFilterTemplate
      }
    }

    setInitialFilterTemplate(_filterTemplate) //this will store also on local storage the selected filter
  }, [{ error, loading, providedFilterTemplate }])

  return { allFilterTemplate, filterTemplates, initialFilterTemplate }
}
